import styled from '@emotion/styled'

export const LoaderStyled = styled.div`
  display: flex;
  justify-content: center;
  height: 20em;
`
